<script setup lang="ts">
import BaseButton from '@/shared/components/button/BaseButton.vue'
import SkeletonLoader from '../loader/SkeletonLoader.vue'

interface Props {
  label: string
  index: number
  loading?: boolean
  disabled?: boolean
}

interface Emits {
  (e: 'click'): void
}

defineProps<Props>()
const emits = defineEmits<Emits>()

const model = defineModel<number>({ required: true })

const onClick = (index: number): void => {
  model.value = index
  emits('click')
}
</script>

<template>
  <SkeletonLoader v-if="loading" class="h-8 me-0.5 w-24" />
  <BaseButton
    v-else
    :title="label"
    class="inline-block text-sm p-1.5 px-3 hover:text-brand -mb-px border-gray-500"
    :class="[
      index === model
        ? 'bg-white border-x border-t text-brand'
        : 'border-t border-x text-gray-700 bg-gray-100/40',
    ]"
    :disabled="disabled"
    @click="onClick(index)"
  >
    {{ label }}
  </BaseButton>
</template>
